// extracted by mini-css-extract-plugin
export default {"categ":"sideBar_categ__dzg2G"};